import { JOBS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const JobService = {
  getAll: (params: any) => requests.get(`${JOBS_URL}`, params),
  create: (params: any) => requests.post(`${JOBS_URL}`, params),
  getSingle: (id: number) => requests.get(`${JOBS_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.put(`${JOBS_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${JOBS_URL}/${id}`),
  updateFeatured: (id: number, body: { featured: boolean }) =>
    requests.put(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }admin/jobs/featured/${id}`,
      body
    ),
};
